import React, { createContext } from 'react'

import { any, shape, bool, string, object } from 'prop-types'

/**
 * @typedef {Object} TopSectionPropsContextValue
 * @property {boolean} is3dPrintModel - Whether the item is a 3D print model
 * @property {string} currentUsername - The current user's username
 * @property {string} role - The current user's role (guest, user, buyer, seller)
 * @property {boolean} isMobile - Whether the viewport is mobile
 * @property {Object} pageConfig - The page configuration object
 * @property {Object} useCasesAreaData - The use cases area data from BE
 */

/**
 * Context for TopSection server props and derived flags.
 * Eliminates prop drilling for common TopSection data.
 */
export const TopSectionPropsContext = createContext(null)

/**
 * Provider component that wraps TopSection children and exposes server props.
 * The value is computed in TopSection.jsx and passed down once.
 *
 * @param {Object} props
 * @param {TopSectionPropsContextValue} props.value - The context value
 * @param {React.ReactNode} props.children - Child components
 */
export function TopSectionPropsProvider({ value, children }) {
  return (
    <TopSectionPropsContext.Provider value={value}>
      {children}
    </TopSectionPropsContext.Provider>
  )
}

TopSectionPropsProvider.propTypes = {
  value: shape({
    is3dPrintModel: bool.isRequired,
    currentUsername: string,
    role: string,
    isMobile: bool,
    pageConfig: object,
    useCasesAreaData: object,
  }).isRequired,
  // `any` instead of `node` because prop-types' node validator rejects
  // ReactDOM.createPortal() return values ($$typeof: REACT_PORTAL_TYPE).
  children: any.isRequired,
}
